import { Moon } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { IMAGES } from "@/lib/product";

const CASES = [
  ["bedroom", null, "Sommeil", "Des nuits fraîches, enfin calmes", "Le compresseur reste dehors : en mode silencieux, l'unité intérieure descend à 39 dB(A). Vous dormez au frais sans le vrombissement d'un monobloc."],
  ["telework", IMAGES.office, "Télétravail", "Un bureau à bonne température tout l'après-midi", "Gardez la tête froide pendant les pics de chaleur. Lancez la clim depuis votre téléphone avant de vous installer, et passez vos visios sans bruit de fond gênant."],
  ["rooftop", IMAGES.attic, "Sous les toits", "L'appartement parisien sous les toits, vivable en été", "Derniers étages et combles accumulent la chaleur. Le PortaSplit rafraîchit sans toucher à la façade ; pour les fenêtres de toit, un support toit est disponible en option."],
];

export const UseCases = () => (
  <section id="usages" data-testid="usecases-section" className="section bg-white">
    <div className="container-x">
      <SectionHead eyebrow="Ce que vous gagnez" title="Concrètement, ça change quoi chez vous ?" />
      <div className="grid md:grid-cols-3 gap-6 mt-12">
        {CASES.map(([id, img, tag, title, desc]) => (
          <article key={id} data-testid={`usecase-${id}`} className="usecase-card group">
            <div className="aspect-[4/3] overflow-hidden">
              {img ? (
                <img src={img} alt={title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
              ) : (
                <div className="w-full h-full flex flex-col items-center justify-center gap-3 bg-[#062033] text-white">
                  <Moon className="w-12 h-12 text-sky-300" />
                  <span className="font-display text-4xl font-extrabold">39 dB(A)</span>
                  <span className="text-xs uppercase tracking-[0.18em] text-sky-200">mode silencieux</span>
                </div>
              )}
            </div>
            <div className="p-6 sm:p-7">
              <span className="eyebrow">{tag}</span>
              <h3 className="font-display text-xl font-bold text-slate-900 mt-4 leading-snug">{title}</h3>
              <p className="text-slate-600 leading-relaxed mt-2 text-[15px]">{desc}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
